import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const LitterConditionList = Loadable(lazy(() => import("./LitterConditionList")));
const LitterConditionForm = Loadable(lazy(() => import("./LitterConditionForm")));

const litterConditionRoutes = [
  {
    path: "/LitterCondition/LitterConditionList",
    element: <LitterConditionList />,
    permission: PERMISSIONS.LitterConditions.Menu,
  },
  {
    path: "/LitterCondition/LitterConditionForm",
    element: <LitterConditionForm />,
  },
  {
    path: "/LitterCondition/LitterConditionForm/:litterConditionId",
    element: <LitterConditionForm />,
  },
];

export default litterConditionRoutes;
